export const getId = (): string => window.location.pathname.split('/').pop() || '';
